import { EventEmitter, OnDestroy, Output } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { SyncService } from '@scaffold/services/sync.service';
import { ZipService } from '@scaffold/services/zip.service';
import { CourseImportService } from '@services/course-import.service';
import {
  NotificationMessageData,
  NotificationMessageIcon,
  RetryServices,
} from '../notification-sidebar.component';

@Component({
  selector: 'scaffold-notification-message',
  templateUrl: './notification-message.component.html',
  styleUrls: ['./notification-message.component.scss'],
  standalone: false,
})
export class NotificationMessageComponent implements OnInit, OnDestroy {
  public notificationMessageIcon: typeof NotificationMessageIcon =
    NotificationMessageIcon;
  constructor(
    private zipService: ZipService,
    private courseImportService: CourseImportService,
    private syncService: SyncService
  ) {}
  @Input() shouldHaveBorderBottom: boolean;
  @Input() message: NotificationMessageData;
  @Output() closeNotification = new EventEmitter<any>();

  ngOnInit(): void {}

  ngOnDestroy() {}

  close() {
    this.closeNotification.emit(this.message);
  }

  action() {
    if (this.message.action) {
      this.message.action();
    }
  }

  retryOperation() {
    switch (this.message.retry.service) {
      case RetryServices.zip: {
        return this.zipService.zipFolder(this.message.retry.data);
      }

      case RetryServices.zipWithFilesAndFolders: {
        return this.zipService.zipFiles(
          this.message.retry.data.prefix,
          this.message.retry.data.files,
          this.message.retry.data.folders
        );
      }

      case RetryServices.courseImport: {
        return this.courseImportService.import(this.message.retry.data);
      }

      case RetryServices.viewSync: {
        const rawData = this.message.retry.data || {};
        const rememberedData = this.syncService.getLastPushRequest(
          rawData.id,
          rawData.type
        );
        const data = rememberedData
          ? { ...rememberedData, ...rawData }
          : rawData;
        const {
          id,
          title,
          type,
          children,
          syncType,
          integrations,
          syncNewCourse,
          extra,
        } = data;
        return this.syncService.push(
          id,
          type,
          title,
          children,
          syncType,
          integrations,
          syncNewCourse,
          extra
        );
      }
    }
  }
}
